<template>
  <simple-page header="用户授权单位" @query="query" backable>

    <template #buttons>
      <btn-add @click="compChooseFlag = true">添加单位授权</btn-add>
    </template>

    <template #form>
      <el-form inline>
        <el-form-item label="单位名称">
          <el-input v-model="queryForm.compName" clearable placeholder="请输入单位名称模糊查询"></el-input>
        </el-form-item>
      </el-form>
    </template>

    <el-table stripe :data="records" :border="true" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="compName" label="单位名称" min-width="300"></el-table-column>
      <column-code-type prop="compType" code-type="COMP_TYPE" label="单位类型" align="center" min-width="100"></column-code-type>
      <column-code-type prop="compLevel" code-type="areaLevel" label="单位层级" align="center" min-width="100"></column-code-type>
      <el-table-column prop="areaName" label="所属地区" align="center" min-width="150"></el-table-column>
      <el-table-column prop="valid" label="状态" align="center" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.valid" class="color-success">启用</span>
          <span v-else class="color-error">禁用</span>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作" width="80" align="center" fixed="right" v-slot="{row}">
        <btn-delete size="small" icon="" @click="del(row)"></btn-delete>
      </el-table-column>
    </el-table>

    <comp-choose-dialog :visible.sync="compChooseFlag" @choose="addComp"></comp-choose-dialog>
  </simple-page>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import CodeSelect from "@/components/base/CodeSelect";
import SessionStore from "@/utils/SessionStore";
import SimplePage from "@/components/page/SimplePage.vue";
import ColumnCodeType from "@/components/tableColumns/ColumnCodeType.vue";
import BtnDelete from "@/components/btns/BtnDelete.vue";
import BtnAdd from "@/components/btns/BtnAdd.vue";
import CompChooseDialog from "@/components/company/CompChooseDialog.vue";

export default {
  components: {CompChooseDialog, BtnAdd, BtnDelete, ColumnCodeType, SimplePage, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      compChooseFlag: false,
      userId: "",
      records: [],
      queryForm: {
        compId: "",
        page: 1,
        limit: 10
      },
    }
  },
  created() {
    this.userId = this.$route.query.userId;
    this.query();
  },
  methods: {
    query(){
      this.loading = true;
      this.postForm("/user-comp/list",{userId: this.userId},true).then(dr => {
        this.records = dr.rows;
      }).finally(dr => {
        this.loading = false;
      });
    },
    addComp(row){
      if(this.records.find(item => item.compId == row.compId)){
        this.$message.warning("该单位授权已存在！");
        return;
      }
      this.loading = true;
      this.postForm("/user-comp/save",{
        userId: this.userId,
        compId: row.compId
      }, true).then(()=>{
        this.query();
      }).finally(()=>{
        this.loading = false;
      })
    },
    del(row) {
      this.$confirm("确定要删除该授权吗？").then(()=>{
        this.postForm("/user-comp/delete",{
          userId: this.userId,
          compId: row.compId
        }, true).then(()=>{
          this.query();
        });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.role-transfer{
    display:flex;
    justify-content: center;
    align-items: center;
}
</style>
